var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 22.5C41.3284 22.5 42 23.1716 42 24C42 24.8284 41.3284 25.5 40.5 25.5H7.5C6.67157 25.5 6 24.8284 6 24C6 23.1716 6.67157 22.5 7.5 22.5H40.5Z",
    fill: "#7681FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9393 9.43946C26.5251 8.85368 27.4746 8.85368 28.0604 9.43946L41.5604 22.9395C42.1462 23.5252 42.1462 24.4748 41.5604 25.0606L28.0604 38.5606C27.4746 39.1463 26.5251 39.1463 25.9393 38.5606C25.3536 37.9748 25.3536 37.0252 25.9393 36.4395L38.3788 24L25.9393 11.5606C25.3536 10.9748 25.3536 10.0252 25.9393 9.43946Z",
    fill: "#7681FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBig);
export default __webpack_public_path__ + "static/media/arrow-right-big.b380d577c25a885962a4f9cd0786fb18.svg";
export { ForwardRef as ReactComponent };